// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProposalNameQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ProposalNameQuery = { __typename?: 'Query', proposals: { __typename?: 'ProposalConnection', edges?: Array<{ __typename?: 'ProposalEdge', node?: { __typename?: 'Proposal', id: string, displayName: string, household: { __typename?: 'Household', id: string } } | null } | null> | null } };

export const Operations = {
  Query: {
    ProposalName: 'ProposalName' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const ProposalNameDocument = gql`
    query ProposalName($id: ID!) {
  proposals(where: {id: $id}) {
    edges {
      node {
        id
        displayName
        household {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useProposalNameQuery__
 *
 * To run a query within a React component, call `useProposalNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useProposalNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProposalNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProposalNameQuery(baseOptions: Apollo.QueryHookOptions<ProposalNameQuery, ProposalNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProposalNameQuery, ProposalNameQueryVariables>(ProposalNameDocument, withFetchPolicyContext(options));
      }
export function useProposalNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProposalNameQuery, ProposalNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProposalNameQuery, ProposalNameQueryVariables>(ProposalNameDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useProposalNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProposalNameQuery, ProposalNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProposalNameQuery, ProposalNameQueryVariables>(ProposalNameDocument, withFetchPolicyContext(options));
        }
export type ProposalNameQueryHookResult = ReturnType<typeof useProposalNameQuery>;
export type ProposalNameLazyQueryHookResult = ReturnType<typeof useProposalNameLazyQuery>;
export type ProposalNameSuspenseQueryHookResult = ReturnType<typeof useProposalNameSuspenseQuery>;
export type ProposalNameQueryResult = Apollo.QueryResult<ProposalNameQuery, ProposalNameQueryVariables>;